import { useTranslation } from 'react-i18next';
import { FilterPopover } from 'src/components/molecules/filter-popover';
import { BookingRulesType } from 'src/features/booking-rules/api/types/response/booking-rule.response';
import { bookingRulesTypeTranslations } from 'src/features/booking-rules/constants/booking-rules-type-translations';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { FilterGroup } from 'src/types/interfaces/filter-group';
import { Filters } from 'src/types/interfaces/filters';
import { getSelectedFilters } from 'src/utils/filters/get-selected-filters';
import { toggleFilterItemSelection } from 'src/utils/filters/toggle-filter-item-selection';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
}

export const BookingRulesTypeFilterPopover = ({
  filters,
  handleChangeFilterValue,
}: Props) => {
  const { t } = useTranslation('bookingRules');

  const filterGroup: FilterGroup<BookingRulesType> = {
    id: 1,
    type: 'durationType',
    label: t('common.columns.durationType'),
    singleOption: false,
    items: [
      {
        label: t(bookingRulesTypeTranslations[BookingRulesType.HOURLY]),
        value: BookingRulesType.HOURLY,
      },
      {
        label: t(bookingRulesTypeTranslations[BookingRulesType.DAILY]),
        value: BookingRulesType.DAILY,
      },
    ],
  };

  return (
    <FilterPopover
      title={filterGroup.label}
      withStatusBadge
      selected={getSelectedFilters(filters, filterGroup.type)}
      onChange={option => {
        toggleFilterItemSelection(
          filterGroup.type,
          option,
          filterGroup.singleOption,
          filters,
          handleChangeFilterValue,
          filterGroup.filterOperator,
        );
      }}
      options={filterGroup.items.map(item => ({
        label: item.label,
        value: item.value,
      }))}
    />
  );
};
